import React from "react";
import PropTypes from "prop-types";
import styles from "./LoadingScreenFluent.scss";
import { makeStyles, Text, Field, ProgressBar } from "@fluentui/react-components";
import qs from "qs";
import { FormattedMessage } from "react-intl";
import configManager from "../../singleton/ConfigManager";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    width: "500px",
    maxWidth: "100%",
    padding: "24px",
    paddingBottom: "12px"
  },
  cardFooter: {
    width: "100%",
    backgroundColor: "rgba(20, 20, 20, 1)"
  },
  subtitle: {
    color: "var(--color-text-secondary)"
  },
  textLoadingVerse: {
    color: "var(--color-text-primary)",
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "var(--Line-height-500, 28px)"
  },
  loadingObjectsText: {
    color: "var(--color-text-secondary)",
    textAlign: " center",
    fontFamily: " var(--Font-family-Base, 'Segoe UI')",
    fontSize: " 10px",
    fontStyle: " normal",
    fontWeight: " 400",
    lineHeight: " normal"
  },
  emphasizedText: {
    color: "var(--color-text-primary)"
  },
  loadingObjectsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
    maxWidth: "500px",
    paddingLeft: "12px",
    paddingRight: "12px"
  }
});

export function LoadingScreenFluent({ message, backgroundColor, objectCount, loadedCount, hub }) {
  const classes = useStyles();

  const queryString = window.location.search.slice(1);
  const entryPoint = qs.parse(queryString)?.entry;

  const max = Math.max(objectCount || 1, loadedCount || 0);

  return (
    <div
      className={styles.loadingScreenLayout}
      style={{
        backgroundColor: backgroundColor ? backgroundColor : undefined
      }}
    >
      {configManager.config.loadingScreen.showLoadingText && (
        <div className={classes.loadingObjectsContainer}>
          <Text className={classes.textLoadingVerse}>
            {entryPoint === "meeting" && <>Loading Meeting...</>}
            {entryPoint === "event" && <>Loading Activation...</>}
            {entryPoint !== "meeting" &&
              entryPoint !== "event" &&
              (hub?.name ? (
                <>{hub.name}</>
              ) : (
                <FormattedMessage id="loading-screen.loading-verse" defaultMessage="Loading Verse" />
              ))}
          </Text>

          <Field validationMessage={message} validationState="none">
            <ProgressBar max={max} value={loadedCount || 0} thickness="large" />
          </Field>
        </div>
      )}
    </div>
  );
}

LoadingScreenFluent.propTypes = {
  message: PropTypes.node,
  infoMessages: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.node.isRequired,
      message: PropTypes.node.isRequired
    })
  ),
  scene: PropTypes.object,
  objectCount: PropTypes.number,
  loadedCount: PropTypes.number,
  environmentLoaded: PropTypes.bool,
  allObjectsLoaded: PropTypes.bool,
  donePreloading: PropTypes.bool,
  backgroundColor: PropTypes.string,
  hub: PropTypes.object
};
